import { DealernetApi } from "./DealernetApi";

export class InvoiceService {
  static GetInvoicesByDealerCodes(AccountID, UserID, StartDate, EndDate, DealerCodes) {
    return DealernetApi.client().post("Invoice/GetInvoicesByDealerCodes", {
      AccountID,
      UserID,
      StartDate,
      EndDate,
      DealerCodes
    });
  }

  static GetInvoiceDetail(accountId, userId, invoiceId, invoiceSource) {
    return DealernetApi.client().get("Invoice/InvoiceDetail", {
      params: {
        accountId: accountId,
        userId: userId,
        invoiceId: invoiceId,
        invoiceSource: invoiceSource
      }
    });
  }

  static SearchInvoicesByDocumentOrPart(
    AccountId,
    UserId,
    PartNumber,
    DocumentNumber,
    DealerCodes
  ) {
    return DealernetApi.client().post(
      "Invoice/SearchInvoicesByDocumentOrPart",
      {
        AccountId,
        UserId,
        PartNumber,
        DocumentNumber,
        DealerCodes
      }
    );
  }

  static SearchCreditMemosByDocumentOrPart(
    AccountId,
    UserId,
    PartNumber,
    DocumentNumber,
    DealerCodes
  ) {
    return DealernetApi.client().post(
      "Invoice/SearchCreditMemosByDocumentOrPart",
      {
        AccountId,
        UserId,
        PartNumber,
        DocumentNumber,
        DealerCodes
      }
    );
  }

  static getExportAction() {
    return window.appGlobals.API_URL + "Invoice/PrintInvoices";
  }
}
